export const CORE_API_URL = 'api/core';
